export const selectLeaves = (state) => state.companyLeaveDetails?.leaves || [];
export const selectLeaveLoading = (state) =>
  state.companyLeaveDetails?.loading || false;
export const selectLeaveError = (state) =>
  state.companyLeaveDetails?.error || null;
export const selectSelectedLeave = (state) =>
  state.companyLeaveDetails?.selectedLeave || null;
export const selectUpdatingAction = (state) =>
  state.companyLeaveDetails?.updatingAction || false;

// Yearly report selectors
export const selectYearlyLeaveReport = (state) =>
  state.companyLeaveDetails?.yearlyReport || null;
export const selectYearlyLeaveReportLoading = (state) =>
  state.companyLeaveDetails?.yearlyLoading || false;
export const selectYearlyLeaveReportError = (state) =>
  state.companyLeaveDetails?.yearlyError || null;
export const selectYearlyLeavePagination = (state) =>
  state.companyLeaveDetails?.yearlyPagination || {
    year: new Date().getFullYear(),
    title: "",
    totalEmployees: 0,
  };
